// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { ServiceHoursAreaId } from './ServiceHoursAreaId'
import { ServiceHoursAreaNavigation } from './ServiceHoursAreaNavigation'
import { ServiceHoursAreaRoutes } from './ServiceHoursAreaRoutes'

const LazyServiceHoursComponent = lazy(() => import('./ServiceHoursArea'))

const ServiceHoursComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyServiceHoursComponent />
  </SuspenseLoadingWrapper>
)

export const ServiceHoursArea = {
  id: ServiceHoursAreaId,
  requiredRight: BoumRight.AREA_SERVICE_HOURS,
  NavigationComponent: ServiceHoursAreaNavigation,
  route: {
    path: ServiceHoursAreaRoutes.route,
    component: ServiceHoursComponent,
  },
}
